import auth0 from 'auth0-js'

import config from '../config'

const webAuth = new auth0.WebAuth({
    domain: config.auth.domain,
    clientID: config.auth.clientID
})

// Authenticates the user with the given username (email) and password.
const authenticate = ({ username, password }) => {
    return new Promise((resolve, reject) => {
        webAuth.login({
            username,
            password,
            responseType: 'token id_token',
            audience: 'https://myfeel.auth0.com/api/v2/',
            realm: 'Username-Password-Authentication',
            redirectUri: `${config.baseURL}/callback`
        }, (error, result) => {
            error ? reject(error) : resolve(result)
        })
    })
}

// Processes the authentication result.
const handleAuthentication = () => {
    return new Promise((resolve, reject) => {
        webAuth.parseHash((error, result) => {
            if (result && result.accessToken && result.idToken) {
                resolve(result)
            } else {
                reject(error)
            }
        })
    })
}

// Logs out the user that is currently logged in.
const logOut = () => {
    return new Promise((resolve, reject) => {
        webAuth.logout({
            clientID: config.auth.clientID,
            returnTo: config.baseURL
        }, (error, result) => {
            if (result && result.accessToken && result.idToken) {
                resolve(result)
            } else {
                reject(error)
            }
        })
    })
}

// Resets the password for the user with the given email.
const resetPassword = ({ email }) => {
    return new Promise((resolve, reject) => {
        webAuth.changePassword({
            connection: 'Username-Password-Authentication',
            email
        }, (error, result) => {
            if (error) {
                reject(error)
            } else {
                resolve(result)
            }
        })
    })
}

export {
    authenticate,
    handleAuthentication,
    logOut,
    resetPassword
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js